/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RpTable, { Row, Loading } from 'rp-react-table';
import axios from 'axios';

import raceColumns from '../columns';
import detailsColumns from './columns';

class RaceRow extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            detailsData: [],
            expanded: false,
            needFetch: true,
        };
    }

    fetchDetails = () => {
        const { horseId, timePeriod, data: { category } } = this.props;
        const startYear = parseInt(timePeriod, 10) || new Date().getFullYear();
        const raceType = encodeURI(category);

        axios.get(`horse/accordion-statistics/${horseId}/${startYear}/${raceType}`)
            .then(({ data: { progenyStatisticsTop, progenyBroodmareSiresStatisticsTop } }) => {
                this.setState({
                    detailsData: progenyStatisticsTop || progenyBroodmareSiresStatisticsTop,
                    needFetch: false,
                });
            })
            .catch((error) => {
                console.warn(error);
                this.setState({ needFetch: false });
            });
    };

    /* to not pollute global Row component we adding handler for tbody
     and preventing click handling on second table row by css pointer-events: none
     and checking target.nodeName */
    toggleDetails = (event) => {
        if (event.target.nodeName === 'A') { return; }

        this.setState(state => ({ expanded: !state.expanded }));

        if (this.state.needFetch) {
            this.fetchDetails();
        }
    };

    render() {
        const { detailsData, expanded, needFetch } = this.state;

        return (
            <tbody
                className={expanded && 'hp-progeny-statistics__expanded'}
                onClick={this.toggleDetails}
            >
                <Row
                    rowData={this.props.data}
                    columns={raceColumns}
                    setRowClass={() => 'hp-progeny-statistics__row'}
                />
                { expanded && (
                    <tr className="ui-table__row">
                        <td colSpan="10" className="hp-progeny-statistics__detailsTable">
                            { needFetch ? <Loading /> : (
                                <RpTable
                                    data={detailsData}
                                    columns={detailsColumns(this.props.data.broodmareCategory)}
                                    uiType={5}
                                />
                            )}
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }
}

RaceRow.propTypes = {
    horseId: PropTypes.string,
    timePeriod: PropTypes.string,
    data: PropTypes.shape({
        category: PropTypes.string,
        winners: PropTypes.number,
        runners: PropTypes.number,
        percentWinnersRunners: PropTypes.number,
        wins: PropTypes.number,
        runs: PropTypes.number,
        percentWinsRuns: PropTypes.number,
        place2ndNumber: PropTypes.number,
        place3rdNumber: PropTypes.number,
        totalPrizeMoney: PropTypes.number,
        broodmareCategory: PropTypes.bool,
    }).isRequired,
};

export default RaceRow;



// WEBPACK FOOTER //
// ./src/js/horse/progenyStatistics/raceRow/RaceRow.jsx